// Socket.IO connection
import io from 'socket.io-client';

const PROD_BACKEND_HOST = 'awards.portnoy.org';

export function parseCookie(cookies: string): Map<string, string> {
  if (!cookies) {
    return new Map();
  }
  return cookies.split(';')
    .map(cookie => cookie.split('='))
    .reduce((mapping, vals) => {
      return mapping.set(decodeURIComponent(vals[0].trim()),
        decodeURIComponent(vals[1].trim()));
    }, new Map());
}

export function savedUsername(): string | undefined {
  const cookies = parseCookie(document.cookie);
  const cookieUsername = cookies.get('username');
  return cookieUsername;
}

// Use HTTPS on port 5022 if frontend is HTTPS; otherwise HTTP on 5021
function getBackendUrl(): URL {
  const backendUrl = new URL(window.location.href);
  if (window.location.protocol === 'https:') {
    backendUrl.protocol = 'https:';
    backendUrl.port = '5022';
  } else {
    backendUrl.protocol = 'http:';
    backendUrl.port = '5021';
  }
  if (process.env.REACT_APP_BACKEND === 'production') {
    backendUrl.hostname = PROD_BACKEND_HOST;
    backendUrl.port = '5022';
    backendUrl.protocol = 'https:';
  }
  return backendUrl;
}

export function fetchApi(request: string, show_id?: string, options?: any): Promise<any> {
  const backendUrl = getBackendUrl();
  backendUrl.pathname = request;

  const show = show_id ? show_id : backendUrl.searchParams.get('show');
  var query_params = "";
  if (show) {
    query_params = `show=${show}`;
  }
  backendUrl.search = query_params;

  return fetch(backendUrl.href, options)
    .then((response) => {
      if (!response.ok) {
        return response.json().then(body => { throw new Error(body.error || `HTTP error ${response.status}`); });
      }
      return response.json();
    });
}

// Returns URL fragment for request, with necessary params.
export function buildLinkUrl(request: string):string  {
  const linkUrl = new URL(window.location.href);
  linkUrl.pathname = request;
  const show = linkUrl.searchParams.get('show');
  if (show) {
    linkUrl.search = `show=${show}`;
  }

  // Only return request and params
  return linkUrl.toString().substring(linkUrl.origin.length)
}

const socket = io(getBackendUrl().origin);

export function subscribeToMasterBallotUpdates(callback: (data: { show_id: string, timestamp: string }) => void): () => void {
  socket.on('masterBallotUpdated', callback);
  return () => socket.off('masterBallotUpdated', callback);
}

export { socket };